var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon24 / user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58058 19.3306C6.75268 18.1585 8.3424 17.5 10 17.5H20C21.6576 17.5 23.2473 18.1585 24.4194 19.3306C25.5915 20.5027 26.25 22.0924 26.25 23.75V26.25C26.25 26.9404 25.6904 27.5 25 27.5C24.3096 27.5 23.75 26.9404 23.75 26.25V23.75C23.75 22.7554 23.3549 21.8016 22.6516 21.0984C21.9484 20.3951 20.9946 20 20 20H10C9.00544 20 8.05161 20.3951 7.34835 21.0984C6.64509 21.8016 6.25 22.7554 6.25 23.75V26.25C6.25 26.9404 5.69036 27.5 5 27.5C4.30964 27.5 3.75 26.9404 3.75 26.25V23.75C3.75 22.0924 4.40848 20.5027 5.58058 19.3306Z",
    fill: "#00720B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5C12.9289 5 11.25 6.67893 11.25 8.75C11.25 10.8211 12.9289 12.5 15 12.5C17.0711 12.5 18.75 10.8211 18.75 8.75C18.75 6.67893 17.0711 5 15 5ZM8.75 8.75C8.75 5.29822 11.5482 2.5 15 2.5C18.4518 2.5 21.25 5.29822 21.25 8.75C21.25 12.2018 18.4518 15 15 15C11.5482 15 8.75 12.2018 8.75 8.75Z",
    fill: "#00720B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a69ef76661b16af1702c8625947b6bf7.svg";
export { ForwardRef as ReactComponent };